import React, { useContext, useEffect, useState, useCallback } from 'react';
import styled, { keyframes } from 'styled-components';
import { WidgetContext } from '../WidgetContext';
import css from 'classnames';
import tecobiIcon from '../assets/tecobi-icon.png';
import Close from './Close';

declare const ga: any;
declare const gtag: any;
declare const fbq: any;

const TECOBILogo = styled((props) => (
  <img src={tecobiIcon} alt='TECOBI Logo' {...props} />
))`
  flex: 0 0 auto;
  height: 21.29px;
  width: 25px;
`;

const fadeIn = keyframes`
0% {
  opacity: 0;
  transform: translateY(40px) scale(3);
}
100% {
  opacity: 1;
  transform: translateY(10px) scale(1);
}
`;
const fadeOut = keyframes`
  0% {
    opacity: 1;
    transform: translateY(0);
  }
  100% {
    opacity: 0;
    transform: translateY(-10px);
  }
`;

export default styled(({ className, ...rest }) => {
  const { state, dispatch } = useContext(WidgetContext);
  const { smswidgetconfig: widgetConfig } = state.config;
  const [showChatBubble, setShowChatBubble] = useState(false);
  const [chatBubbleClassName, setChatBubbleClassName] = useState('');

  console.log('sms widgdet: ', widgetConfig);

  const ChatBubble = styled.div`
    position: fixed;
    // Mobile devices

    @media screen and (max-width: 450px) {
      // top: 680px
      bottom: 100px;
    }
    @media screen and (max-width: 390px) {
      bottom: 100px;
    }

    bottom: 100px;
    line-height: 1.2;
    z-index: 999999999;
    width: 150px;
    right: ${widgetConfig.pin_left ? 'unset' : '10px'};
    left: ${widgetConfig.pin_left ? '10px' : 'unset'};
    transform: translateX(50%);
    background-color: #fff;
    color: #000;
    border-radius: 6px;
    box-shadow: 0 0 10px rgba(0, 0, 0, 0.2);
    font-family: Roboto, 'Helvetica Neue', sans-serif;
    padding: 10px;
    opacity: 0;
    &.chatBubbleFadein {
      animation: ${fadeIn} 0.6s cubic-bezier(0.175, 0.885, 0.32, 1.275) forwards;
    }

    &:after {
      content: '';
      position: absolute;
      bottom: -20px;
      left: 70%;
      margin-left: -10px;
      border-width: 10px;
      border-style: solid;
      border-color: transparent transparent ${widgetConfig.background_color}
        transparent;
    }

    &.fadeOut {
      animation: ${fadeOut} 0.5s ease-in-out forwards;
    }

    .close-button {
      position: absolute;
      top: 5px;
      right: 5px;
      cursor: pointer;
    }
  `;

  const CloseButton = styled(Close)`
    cursor: pointer;
    position: absolute;
    height: 18px;
    top: 5px;
    right: 5px;
    width: 18px;
  `;

  const getLocalStorageValue = (key: any, defaultValue: any) => {
    const value = localStorage.getItem(key);
    if (value === null) {
      return defaultValue;
    }
    return JSON.parse(value);
  };

  const setLocalStorageValue = (key: any, value: any) => {
    localStorage.setItem(key, JSON.stringify(value));
  };

  const isSessionExpired = (sessionTime: any) => {
    return new Date().getTime() - Number(sessionTime) > 86400000; // 24 hours in milliseconds
    // return new Date().getTime() - sessionTime > 10000; // 24 hours in milliseconds
  };

  // Delay 1.5 seconds before showing the chat button animation
  useEffect(() => {
    const timeout = setTimeout(() => {
      setChatBubbleClassName('chatBubbleFadein');
    }, 1500);
    // Cleanup the timeout if the component unmounts or if the dependency array changes
    return () => {
      clearTimeout(timeout);
    };
  }, []); // Empty dependency array ensures the effect only runs once, on component mount

  useEffect(() => {
    const sessionTime = getLocalStorageValue('sessionTime', null);
    if (sessionTime === null || isSessionExpired(sessionTime)) {
      setShowChatBubble(true);
    }
  }, []);

  const handleCloseChatBubble = () => {
    setShowChatBubble(false);
    setLocalStorageValue('sessionTime', new Date().getTime());
  };

  const openModal = useCallback(() => {
    setShowChatBubble(false);
    dispatch({ type: 'set', value: { isPopupOpen: true } });

    // Send click event to ga or gtag
    // @ts-ignore
    if (
      // @ts-ignore
      typeof window.ga === 'function' &&
      // @ts-ignore
      typeof window.ga.getAll === 'function'
    ) {
      console.log('Sending click event to Google Analytics (ga)');
      // @ts-ignore
      window.ga.getAll().forEach(function (tracker: any) {
        tracker.send('event', 'tecobi_widget', 'click');
      });
    }

    if (typeof gtag === 'function') {
      console.log('Sending click event to Google Ads (gtag)');
      (window as any).gtag('event', 'tecobi_widget_click');
    }
  }, [dispatch]);

  const handleOutsideClick = useCallback(
    (event: any) => {
      event.preventDefault();
      openModal();
    },
    [openModal]
  );

  useEffect(() => {
    // Get all classname DOM element references.
    const elements = document.getElementsByClassName('tecobi-widget-toggle');
    console.log('ELEMENTS: ', elements);

    // Listen to clicks outside the react component to trigger opening the chat bubble for all elements
    for (let i = 0; i < elements.length; i++) {
      elements[i]?.addEventListener('click', handleOutsideClick);
    }
    return () => {
      // remove listener
      for (let i = 0; i < elements.length; i++) {
        elements[i]?.removeEventListener('click', handleOutsideClick);
      }
    };
  }, [handleOutsideClick]);

  if (!widgetConfig.is_enabled) {
    return null;
  }

  return (
    <div className='tecobi-fab-wrapper'>
      {showChatBubble && (
        <ChatBubble
          className={`close-button ${chatBubbleClassName}`}
          onClick={handleCloseChatBubble}
        >
          <CloseButton color={'black'} onClick={handleCloseChatBubble} />
          <p>
            Instantly communicate with real humans that can answer all your
            questions{' '}
            <span role='img' aria-label='raised hand'>
              🙋‍♀️🙋‍♂️
            </span>{' '}
            via text message!
          </p>
        </ChatBubble>
      )}
      <div
        style={{
          backgroundColor: widgetConfig.background_color,
          color: widgetConfig.text_color,
          right: widgetConfig.pin_left ? 'unset' : '20px',
          left: widgetConfig.pin_left ? '20px' : 'unset',
        }}
        className={css(className, 'tecobi-fab', {
          circle: state.config.smswidgetconfig.button_circle,
          bounceInRight: !state.config.smswidgetconfig.pin_left,
          bounceInLeft: state.config.smswidgetconfig.pin_left,
        })}
        onClick={openModal}
        {...rest}
      >
        <TECOBILogo />
        <span>{widgetConfig.button_text}</span>
      </div>
    </div>
  );
})`
  align-items: center;
  border-radius: 6px;
  box-shadow: 0 0 10px rgba(0, 0, 0, 0.2);
  display: inline-flex;
  cursor: pointer;
  flex-direction: row;
  flex-wrap: nowrap;
  font-size: 16px;
  font-family: Roboto, 'Helvetica Neue', sans-serif;
  padding: 8px 10px;
  text-transform: uppercase;
  // display: inline-block;
  font-weight: 700;
  position: fixed;
  bottom: 20px;
  // right: 20px;
  z-index: 10000000000;

  &:hover {
    filter: brightness(110%);
    transition: filter linear 0.2s;
  }

  span {
    margin-left: 7px;
  }
  /* Define the animation properties */
  @keyframes tecobi-bounceInRight {
    0%,
    60%,
    75%,
    90%,
    100% {
      animation-timing-function: cubic-bezier(0.215, 0.61, 0.355, 1);
    }
    0% {
      opacity: 0;
      transform: translate3d(3000px, 0, 0);
    }
    60% {
      opacity: 1;
      transform: translate3d(-25px, 0, 0);
    }
    75% {
      transform: translate3d(10px, 0, 0);
    }
    90% {
      transform: translate3d(-5px, 0, 0);
    }
    100% {
      transform: none;
    }
  }

  /* Define the animation name to use */
  &.bounceInRight {
    animation-name: tecobi-bounceInRight;
    animation-duration: 1s;
    animation-timing-function: ease;
    animation-delay: 0s;
    animation-iteration-count: 1;
    animation-direction: normal;
    animation-fill-mode: none;
    animation-play-state: running;
  }

  /* Define the animation properties */
  @keyframes tecobi-bounceInLeft {
    0%,
    60%,
    75%,
    90%,
    100% {
      animation-timing-function: cubic-bezier(0.215, 0.61, 0.355, 1);
    }
    0% {
      opacity: 0;
      transform: translate3d(
        -3000px,
        0,
        0
      ); /* Update to -3000px for left direction */
    }
    60% {
      opacity: 1;
      transform: translate3d(
        25px,
        0,
        0
      ); /* Update to 25px for left direction */
    }
    75% {
      transform: translate3d(
        -10px,
        0,
        0
      ); /* Update to -10px for left direction */
    }
    90% {
      transform: translate3d(5px, 0, 0); /* Update to 5px for left direction */
    }
    100% {
      transform: none;
    }
  }

  /* Define the animation name to use */
  &.bounceInLeft {
    animation-name: tecobi-bounceInLeft;
    animation-duration: 1s;
    animation-timing-function: ease;
    animation-delay: 0s;
    animation-iteration-count: 1;
    animation-direction: normal;
    animation-fill-mode: none;
    animation-play-state: running;
  }

  &.circle {
    align-items: center;
    border-radius: 100%;
    justify-content: center;
    padding: 0;
    height: 60px;
    width: 60px;
    img {
      height: 40px;
      flex: 0 0 40px;
      width: 40px;
    }

    span {
      display: none;
    }
  }

  .tecobi-fab-wrapper {
    position: relative;
    height: 100vh;
    width: 100vw;
    display: flex;
    justify-content: center;
    align-items: center;
  }
`;
